var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingShows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C5.55228 0 6 0.44772 6 1V2H14V1C14 0.44772 14.4477 0 15 0C15.5523 0 16 0.44772 16 1V2H17C18.6569 2 20 3.34315 20 5V12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12V8H2V17C2 17.5523 2.44772 18 3 18H8C8.5523 18 9 18.4477 9 19C9 19.5523 8.5523 20 8 20H3C1.34315 20 0 18.6569 0 17V5C0 3.34315 1.34315 2 3 2H4V1C4 0.44772 4.44772 0 5 0ZM3 4C2.44772 4 2 4.44772 2 5V6H18V5C18 4.44772 17.5523 4 17 4H3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 15.7071C15.9024 15.3166 15.9024 14.6834 16.2929 14.2929C16.6834 13.9024 17.3166 13.9024 17.7071 14.2929L19.7071 16.2929C20.0976 16.6834 20.0976 17.3166 19.7071 17.7071L17.7071 19.7071C17.3166 20.0976 16.6834 20.0976 16.2929 19.7071C15.9024 19.3166 15.9024 18.6834 16.2929 18.2929L17.5858 17L16.2929 15.7071Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2929 14.2929C10.9024 14.6834 10.9024 15.3166 11.2929 15.7071L12.5858 17L11.2929 18.2929C10.9024 18.6834 10.9024 19.3166 11.2929 19.7071C11.6834 20.0976 12.3166 20.0976 12.7071 19.7071L14.7071 17.7071C15.0976 17.3166 15.0976 16.6834 14.7071 16.2929L12.7071 14.2929C12.3166 13.9024 11.6834 13.9024 11.2929 14.2929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingShows);
export default __webpack_public_path__ + "static/media/upcoming-shows.6fd1857e.svg";
export { ForwardRef as ReactComponent };